module.exports = __webpack_public_path__ + "img/tempChanImg.e6da26b9.png";